var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":_vm.viewBox,"fill":_vm.fill}},[_c('g',[_c('path',{staticStyle:{"stroke":"none","fill-rule":"nonzero"},attrs:{"d":"M 24.75 9.027344 L 22.480469 6.75 L 11.25 18 L 22.480469 29.25 L 24.75 26.972656 L 15.800781 18 Z M 24.75 9.027344 "}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }